"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var Row_1 = __importDefault(require("./styledComponents/Row"));
var VirtualizedList_meta_1 = require("./VirtualizedList.meta");
var mobx_1 = require("mobx");
var react_virtualized_1 = require("react-virtualized");
var VirtualizedList = /** @class */ (function (_super) {
    __extends(VirtualizedList, _super);
    function VirtualizedList(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = VirtualizedList_meta_1.VIRTUALIZED_LIST_CATEGORY_KEY;
        _this.componentKey = VirtualizedList_meta_1.VIRTUALIZED_LIST_COMPONENT_KEY;
        _this.updated = 1; // Setting this forces the autosizer to re-render when the component props change
        _this.renderRow = function (_a) {
            var index = _a.index, key = _a.key, style = _a.style, parent = _a.parent;
            return (react_1.default.createElement(react_virtualized_1.CellMeasurer, { key: key, cache: _this.cache, parent: parent, columnIndex: 0, rowIndex: index },
                react_1.default.createElement(Row_1.default, { key: key, style: style }, _this.items[index])));
        };
        _this.cache = new react_virtualized_1.CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: props.defaultRowHeight || 100,
        });
        return _this;
    }
    Object.defineProperty(VirtualizedList.prototype, "items", {
        get: function () {
            return this.props && this.props.items || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VirtualizedList.prototype, "autosizeFn", {
        get: function () {
            var _this = this;
            var _a = this.props.overscanRowCount, overscanRowCount = _a === void 0 ? 3 : _a;
            return function (_a) {
                var width = _a.width, height = _a.height;
                return react_1.default.createElement(react_virtualized_1.List, { updated: _this.updated++, width: width, height: height, rowHeight: _this.cache.rowHeight, rowRenderer: _this.renderRow, rowCount: _this.items.length, overscanRowCount: overscanRowCount });
            };
        },
        enumerable: true,
        configurable: true
    });
    VirtualizedList.prototype.render = function () {
        var className = this.props.className;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            react_1.default.createElement(react_virtualized_1.AutoSizer, { children: this.autosizeFn })));
    };
    __decorate([
        mobx_1.observable
    ], VirtualizedList.prototype, "updated", void 0);
    __decorate([
        mobx_1.observable
    ], VirtualizedList.prototype, "cache", void 0);
    __decorate([
        mobx_1.computed
    ], VirtualizedList.prototype, "items", null);
    __decorate([
        mobx_1.computed
    ], VirtualizedList.prototype, "autosizeFn", null);
    VirtualizedList = __decorate([
        mobx_react_1.observer
    ], VirtualizedList);
    return VirtualizedList;
}(shared_1.ComponentBase));
exports.VirtualizedList = VirtualizedList;
exports.default = shared_1.InjectedStyledComponent(VirtualizedList, VirtualizedList_meta_1.VIRTUALIZED_LIST_CATEGORY_KEY, VirtualizedList_meta_1.VIRTUALIZED_LIST_COMPONENT_KEY);
